// --- START OF FILE src/config/i18n.js ---
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Carga traducciones desde un backend (ej. archivos JSON en /public/locales)
  .use(LanguageDetector) // Detecta el idioma del usuario
  .use(initReactI18next) // Pasa la instancia de i18n a react-i18next
  .init({
    supportedLngs: ['en', 'es'], // Idiomas soportados
    fallbackLng: 'en', // Idioma de respaldo si el detectado no está disponible
    debug: process.env.NODE_ENV === 'development', // Activa logs en desarrollo
    
    // Opciones para LanguageDetector
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // Dónde guardar el idioma seleccionado por el usuario
      lookupLocalStorage: 'reseye-i18n-lng', // Clave para localStorage
    },

    // Opciones para HttpApi (backend)
    // Asume que tus archivos de traducción están en /public/locales/[lng]/[ns].json
    // ej. /public/locales/en/translation.json
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', 
    },

    // Opciones para react-i18next
    react: {
      useSuspense: true, // RECOMENDADO: usa React.Suspense para la carga de traducciones
    },

    // Opcional: define namespaces si tienes múltiples archivos de traducción por idioma
    // ns: ['translation'], // Namespace por defecto
    // defaultNS: 'translation',

    interpolation: {
      escapeValue: false, // React ya se encarga del XSS escaping
    },
  });

export default i18n;
// --- END OF FILE src/config/i18n.js ---